// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9d04dfb","370":"72603e72","449":"118747bc","466":"5634003d","553":"e3a61986","977":"bccdb29c"}[chunkId] + ".chunk.js";
};